import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
import moment from "moment";
Vue.use(Vuex)

const state = {
    interList: [],
    dhcpList: [],
    vlanList: [],
    routeList: [],
    snmpList: [],
    addRouteList: [],
}
const mutations = {
    SET_INTERFACE_DETAILS(state, interData) {
        var tData = {};
        var parseData = interData.message;
        if (Object.keys(state.interList).length == 0) {
            tData[interData.accountId + '-interList'] = parseData;
            state.interList = tData;
        } else {
            Vue.set(state.interList, interData.accountId + '-interList', parseData);
        }
    },
    SET_DHCP_DETAILS(state, dhcpData) {
        var tData = {};
        var parseData = dhcpData.message;
        if (Object.keys(state.dhcpList).length == 0) {
            tData[dhcpData.accountId + '-dhcpList'] = parseData;
            state.dhcpList = tData;
        } else {
            Vue.set(state.dhcpList, dhcpData.accountId + '-dhcpList', parseData);
        }
    },
    ADD_EDIT_DHCP_LIST(state, data) {
        var dhcpData = data.dhcpData;
        var accountId = data.accountId;
        var dataSet = {}
        dataSet = dhcpData,
        state.dhcpList[accountId + "-dhcpList"].dhcpEnabledArr = dataSet;
    },
    DELETE_DHCP_LIST(state, data) {
        var dhcpIds = data.dhcpId;
        var accountId = data.accountId;
        var idx = data.idx;
        if (Object.keys(state.dhcpList).length != 0) {
            var index = state.dhcpList[accountId + "-dhcpList"].dhcpEnabledArr.findIndex(dhcp => dhcp.id == dhcpIds);
            if (index != -1) {
                state.dhcpList[accountId + "-dhcpList"].dhcpEnabledArr.splice(index, 1);
            }
        }
    },
    SET_VLAN_DETAILS(state, vlanData) {
        var tData = {};
        var parseData = vlanData.message;
        if (Object.keys(state.vlanList).length == 0) {
            // tData[vlanData.accountId + '-vlanList'] = parseData;
            tData['vlanList'] = parseData;
            state.vlanList = tData;
        } else {
            // Vue.set(state.vlanList, vlanData.accountId + '-vlanList', parseData);
            Vue.set(state.vlanList, 'vlanList', parseData);
        }
    },
    SET_ROUTE_DETAILS(state, routeData) {
        var tData = {};
        var parseData = routeData.message;
        if (Object.keys(state.routeList).length == 0) {
            tData[routeData.accountId + '-routeList'] = parseData;
            state.routeList = tData;
        } else {
            Vue.set(state.routeList, routeData.accountId + '-routeList', parseData);
        }
    },
    SET_ADDROUTE_DETAILS(state, addRouteData) {
        var tData = {};
        var parseData = addRouteData.message;
        if (Object.keys(state.addRouteList).length == 0) {
            tData[addRouteData.accountId + '-addRouteList'] = parseData;
            state.addRouteList = tData;
        } else {
            Vue.set(state.addRouteList, addRouteData.accountId + '-addRouteList', parseData);
        }
    },
    SET_SNMP_DETAILS(state, snmpData) {
        var tData = {};
        var parseData = snmpData.message;
        if (Object.keys(state.snmpList).length == 0) {
            tData[snmpData.accountId + '-snmpList'] = parseData;
            state.snmpList = tData;
        } else {
            Vue.set(state.snmpList, snmpData.accountId + '-snmpList', parseData);
        }
    },
}
const actions = {
    fetchInterfaceDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/network_settings/index/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                commit('SET_INTERFACE_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createInterfaceSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/index/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchDhcpDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/network_settings/dhcp/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                commit('SET_DHCP_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createDhcpModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/dhcp_add', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        dhcpData: response.data.dhcpData,
                        accountId: postData.currentAccountId,
                    }
                    commit('ADD_EDIT_DHCP_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteDhcpSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/dhcp_pool_delete', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    // var successData = {
                    //     dhcpId: postData.dhcpId,
                    //     accountId: postData.accountId,
                    //     idx: postData.idx,
                    // }
                    // commit('DELETE_DHCP_LIST', successData);
                    location.reload();
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    restartDhcpSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/restart_dhcp', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchVlanDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/network_settings/vlan/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                commit('SET_VLAN_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createVlanModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/add_vlan', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteVlanSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/delete_vlan', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    // var successData = {
                    //     iptvData: postData.stbId,
                    //     accountId: postData.accountId
                    // }
                    // commit('DELETE_SET_TOP_BOX_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchRoutingDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.post("/network_settings/routing/true")
            .then(response => {
                Nprogress.done();
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                commit('SET_ROUTE_DETAILS', response.data);
                }
            })
            .catch(error => console.log(error))
    },
    createRouteModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/add_routes', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    natStatusSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/nat', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteRouteSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/delete', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchAddRoutingDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.post("/network_settings/add_edit_routes/true")
            .then(response => {
                Nprogress.done();
                commit('SET_ADDROUTE_DETAILS', response.data);
            })
            .catch(error => console.log(error))
    },
    fetchSnmpDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.post("/network_settings/snmp/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                commit('SET_SNMP_DETAILS', response.data);
                }
            })
            .catch(error => console.log(error))
    },
    createSnmpModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_settings/add_snmp', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}
const getters = {
    getInterListGetters: state => {
        return state.interList;
    },
    getDhcpListGetters: state => {
        return state.dhcpList;
    },
    getVlanListGetters: state => {
        return state.vlanList;
    },
    getRouteListGetters: state => {
        return state.routeList;
    },
    getSnmpListGetters: state => {
        return state.snmpList;
    },
    getAddRouteListGetters: state => {
        return state.addRouteList;
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}